import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { ButtonAddRounded, ButtonEdit } from '../../../components/Buttons';
import { BaseChip } from '../../../components/Chips';
import { formatMembershipDuration } from '../../../utils/format';
import { formatDate } from '../../../utils/date';

export const LeadershipTable = ({
    control,
    errors,
    leadership,
    disabled,
    onClickAddRoles,
    onClickEditRoles,
    renderAddRolesButton = true
}) => {
    const rolesTemplate = (rowData) => {
        return (
            <div className='membership-chips'>
                {rowData.item.leadership_roles.map((leadership) => (
                    <BaseChip
                        key={`${leadership.role}-${leadership.date_from ?? 'indefinite'}`}
                        label={`${leadership.leader ? '👑' : ''} ${leadership.role} ${formatMembershipDuration(
                            leadership.date_from ? formatDate(leadership.date_from) : null,
                            leadership.date_to ? formatDate(leadership.date_to) : null
                        )}`}
                    />
                ))}
            </div>
        );
    }

    const buttonsBodyTemplate = (rowData) => {
        return (
            <ButtonEdit
                type='button'
                tooltip='Upravit pozice'
                rounded
                onClick={() => onClickEditRoles(rowData.item)}
                disabled={disabled}
            />
        );
    };

    const buttonsHeaderTemplate = () => {
        return (
            <ButtonAddRounded
                rounded
                type='button'
                title='Přidat osobu do vedení'
                onClick={onClickAddRoles}
                disabled={disabled}
            />
        );
    }

    return (
        <DataTable
            value={leadership?.map((item, index) => ({
                item,
                index
            }))}
            removableSort
            sortField='item.last_name'
            sortOrder={1}
            breakpoint='500px'
            emptyMessage='Nebyli vybráni žádní členové'
        >
            <Column field='item.id' header='ID' sortable />
            <Column field='item.first_name' header='Jméno' sortable />
            <Column field='item.last_name' header='Příjmení' sortable />
            <Column body={rolesTemplate} header='Pozice' />
            <Column
                body={buttonsBodyTemplate}
                header={renderAddRolesButton ? buttonsHeaderTemplate : null}
                align='right'
            />
        </DataTable>
    );
};
